import * as React from 'react';
import PortalIdParser from 'PortalIdParser';
import UITruncateString from 'UIComponents/text/UITruncateString';
import useReferenceOptions from 'flow-doctor-lib/hooks/useReferenceOptions';
import { formatPropertyValue } from 'flow-doctor-lib/utils/propertyFormatters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnifiedEventPropertyTableRow = ({
  property,
  propertyDef
}) => {
  const valuesToLabels = useReferenceOptions({
    portalId: PortalIdParser.get(),
    rawOptions: [property.value],
    propertyWrapper: propertyDef
  }, {
    skip: !propertyDef
  });
  return /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("td", {
      children: propertyDef ? propertyDef.property.label || property.name : property.name
    }), /*#__PURE__*/_jsx("td", {
      children: /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsx(UITruncateString, {
          children: formatPropertyValue(valuesToLabels[property.value] || property.value, propertyDef)
        })
      })
    })]
  });
};
export default UnifiedEventPropertyTableRow;